import getRows from '../utils/getRows'
import { useEffect } from 'react'

interface useInitDevicesProps {
  setRows: Function
  setDeleteEntryId: Function
  setShowModal: Function
  setShowOverlay: Function
  filter?: {} | null
  currentCustomer?: {} | null
}

const useInit = (props: useInitDevicesProps) => {
  useEffect(() => {
    //request server when the filter is on null (Filter component initializes the filter object)
    getRows({
      setDeleteEntryId: props.setDeleteEntryId,
      setShowModal: props.setShowModal,
    }).then((data: any) => {
      data.forEach((row: any, index: number, dataArray: any) => {
        dataArray[index]['parent_filter_name'] = row['parentFilter']
          ? row['parentFilter']['name']
          : ''
      })
      props.setRows(data)
      props.setShowOverlay(false)
    })
  }, [props.filter, props.currentCustomer])
}

export default useInit
